import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import Swipeable from 'react-swipeable'
import { withStyles } from '@material-ui/core/styles';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import Icon from '@material-ui/core/Icon';
import LinearProgress from '@material-ui/core/LinearProgress';
import Typography from '@material-ui/core/Typography';

import MetaBox from './inputs/MetaBox'

import {
  capitalize
} from '../helpers'

import {
  get_feedback,
  // reset_feedback,
  get_feedback_by_position
} from '../actions'

const styles = {
  root: {
    flexGrow: 1,
  },
  colorPrimary: {
    color: 'rgba(255,255,255,0)',
    backgroundColor: 'rgba(255,255,255,0)',
  },
  barColorPrimary: {
    color: 'rgba(255,255,255,0)',
    backgroundColor: 'rgba(255,255,255,0)',
  },
}

const mapStateToProps = state => {
  const { fetching, feedback, fetched, items, pagination, errors, skip } = state.feedback
  return {
    feedback: feedback,
    fetching: fetching,
    fetched: fetched,
    feedbacks: items,
    pagination: pagination,
    errors: errors,
    skip: skip
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getFeedback: id => dispatch( get_feedback(id) ),
    getPosition: (skip, filters, sort, order) => dispatch( get_feedback_by_position(skip, filters, sort, order) ),
    // resetFeedback: () => dispatch( reset_feedback() )
  }
}

class ConnectedFeedbackPreview extends React.Component {
  state = {
    loaded: false,
    skip: 0,
    total: 0,
    showBar: false,
    hideBar: true,
    // variant: 'default'
  }

  componentWillMount() {
    // this.props.resetFeedback()
  }

  handleNext() {
    this.props.getPosition(this.state.skip + 1, this.props.filters || {}, this.props.order || '', this.props.sort || '')
  }

  handlePrevious() {
    this.props.getPosition(this.state.skip - 1, this.props.filters || {}, this.props.order || '', this.props.sort || '')
  }

  handleKeyDown(e) {
    if (e.keyCode === 37) {
      this.handlePrevious()
    } else if (e.keyCode === 39 ) {
      this.handleNext()
    }
  }

  swipingLeft(e, absX) {
    this.handleNext()
  }

  swipingRight(e, absX) {
    this.handlePrevious()
  }

  componentDidUpdate(prevProps, prevState) {
    if (!this.props.isopen) {
      return
    }

    if ( this.props.fetching && this.state.showBar === false ) {
      this.setState({showBar: true, hideBar: false})
      setTimeout( function(self) {
        self.setState({hideBar: true})
      }, 1000, this)
    } else if (!this.props.fetching && this.state.showBar) {
      this.setState({showBar: false})
    }

    if ( this.props.feedback_id && this.props.feedback_id !== prevProps.feedback_id && !this.props.fetching ) {
      this.props.getFeedback(this.props.feedback_id)
    }

    if (this.props.fetched && !prevProps.fetched) {
      const {page, per_page} = this.props.pagination
      this.setState({
        total: this.props.feedback.total === null ? this.props.pagination.total : this.props.feedback.total,
        skip: this.props.feedback.skip === null ?
          ((page - 1 ) * per_page ) + this.props.feedbacks.findIndex( q => q.id === this.props.feedback.id ) :
          this.props.feedback.skip
      })
    }
  }
  //
  // handleChange(e) {
  //   const { value } = e.target
  //   this.setState({variant: value})
  // }

  render() {
    if ( !this.props.isopen ) {
      return ''
    }

    if ( !this.props.feedback_id && !this.props.feedback ) {
      return ''
    }

    const { feedback, isopen, handleClose, classes } = this.props
    // const { variant } = this.state

    const { id, questions, template, created_at, user, status, test_id } = feedback

    if ( !id ) {
      return ''
    }

    // let localIndex = -1

    return (
      <Dialog
        className="dialog-wrapper"
        fullScreen={false}
        fullWidth={true}
        maxWidth={'md'}
        open={isopen}
        onKeyDown={this.handleKeyDown.bind(this)}
        onClose={e => {
          handleClose()
        }}
      >
        <DialogContent className="dialog-content">
          <DialogTitle className="linear-progress-preview">
            {
              (this.state.showBar || !this.state.hideBar) ? (
                <LinearProgress />
              ) :   <LinearProgress classes={{ colorPrimary: classes.colorPrimary, barColorPrimary: classes.barColorPrimary }} />
            }
          </DialogTitle>
          <Swipeable
            onSwipingLeft={this.swipingLeft.bind(this)}
            onSwipingRight={this.swipingRight.bind(this)}>

            <Grid container spacing={24} justify="center" className="c-black087 mb-40 body2" alignItems="center">

              <Grid item>
                <Link to ='' className="novisit" onClick={e=>{
                  e.preventDefault()
                  this.handlePrevious()
                }}>Prev</Link>
              </Grid>

              <Grid item>
                {this.state.skip + 1}/{this.state.total}
              </Grid>

              <Grid item>
                <Link to ='' className="novisit" onClick={e=>{
                  e.preventDefault()
                  this.handleNext()
                }}>Next</Link>
              </Grid>

            </Grid>

            <Grid use="feedback data" container spacing={24} justify="center" className="mb-40" alignItems="flex-start">
              <Grid item xs={12} md={5}>
                {
                  questions.map( (q, j) => {
                    const { body, selected, answers } = q
                    return (
                      <React.Fragment key={`q${j}`}>
                        <Typography className="subtitle2 c-black087 mb-24 lh-24 preline">
                          {body}
                        </Typography>
                        <div className="mb-24">
                          {
                            answers.map( (answer, i) => {
                              const opacity = selected === i ? 1 : 0
                              return (
                                <Typography key={`q${j}a${i}`} className="body2 c-black087 mb-8 lh-20 d-flex align-items-center">
                                  <Icon className="c-black054" style={{marginRight: '8px', opacity: opacity, fontSize: 16}}>check_circle</Icon>
                                  {answer}
                                </Typography>
                              )
                            })
                          }
                        </div>
                      </React.Fragment>
                    )
                  })
                }
              </Grid>
              <Grid item xs={12} md={4} className="pt-16">
                <Divider className="mb-24"/>
                  <div className='pl-8 pr-8'>
                    <div className="mb-8">META</div>
                    <div className="mb-8"><MetaBox title="Status" value={capitalize(status)} /></div>
                    <div className="mb-8"><MetaBox title="ID" value={id} /></div>
                    <div className="mb-8"><MetaBox title="User" value={ user.email} /></div>
                    <div className="mb-8"><MetaBox title="Name" value={ user.name } /></div>
                    <div className="mb-8"><MetaBox title="Template" value={ template.name } /></div>
                    <div className="mb-8"><MetaBox title="Instance" value={ test_id } /></div>
                    <div className="mb-8"><MetaBox title="Date Taken" value={ new Date(created_at).toLocaleDateString() } /></div>
                  </div>
                <Divider className="mt-24"/>
              </Grid>
            </Grid>

            <Grid container spacing={24} justify="flex-end">
              <Button className="buttonnoto c-blue" onClick={this.props.handleClose}>Close</Button>
            </Grid>
          </Swipeable>
        </DialogContent>
      </Dialog>
    )
  }
}

const FeedbackPreview = connect(mapStateToProps, mapDispatchToProps)(ConnectedFeedbackPreview)

export default withStyles(styles)(FeedbackPreview)



// WEBPACK FOOTER //
// ./src/js/components/FeedbackPreview.js